export default "__VITE_ASSET__3d2c712c__"